export const DORIM_TIN = '309872412';
export const SUPPORT_PHONE_CALLTO = '+998781137755';
export const SUPPORT_PHONE_FORMATTED = '+998 (78) 113-77-55';
export const TELEGRAM_CHAT_LINK = 'https://t.me/dorim_price';
